import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import useAccessLevel from '../Pages/Organizations/hooks/useAccessLevel'
import errorToast from '../Components/Toasts/ErrorToast'

export default function OrganizationGroupRoute({ children }) {
  const { o_f_id, g_f_id } = useParams()
  const navigate = useNavigate()

  const { isInternalAdmin, hasOrgAdminAccess, groupRole } = useAccessLevel({
    o_f_id,
    g_f_id,
  })

  const hasAccess =
    isInternalAdmin || hasOrgAdminAccess || groupRole === 'Group Administrator'

  useEffect(() => {
    if (!hasAccess) {
      errorToast(`You do not have access to this page.`)
      navigate('/artists')
    }
  }, [hasAccess])

  if (hasAccess) {
    return children
  }

  return null
}

OrganizationGroupRoute.propTypes = {
  children: PropTypes.node,
}
